import React from 'react';
import { useLayout } from './context/layout/LayoutProvider';
import { MicroUnitClassBuilder } from './builders/MicroUnitClassBuilder';
import type { MicroUnitSettings, As } from './ModularTypes/MicroUnitSettings';
import './MicroUnit.css';

const MicroUnit = <T extends As>(props: MicroUnitSettings<T>) => {
  const { context } = useLayout();
  const { children, as } = props;
  const className = MicroUnitClassBuilder.build(props, context.microUnit || {});
  const Component = (as ?? 'p') as React.ElementType;

  const elementProps =
    as === 'label'
      ? { htmlFor: (props as MicroUnitSettings<'label'>).htmlFor }
      : {};

  return (
    <Component {...elementProps} className={className}>
      {children}
    </Component>
  );
};

export default MicroUnit;
